import {ShopperBaskets as SdkShopperBaskets} from 'commerce-sdk-isomorphic';
import {getAppOrigin} from 'coreUtils/url';
import {keysToCamel, convertOcapiFaultToCapiError} from './utils';
import {HTTPError} from 'coreUtils/adapters/sdk';
import {fetch} from 'coreUtils/utils';

/**
 * Extends the SDK ShopperBaskets with OCAPI-only endpoints
 * not available through the standard SCAPI client.
 */
class ShopperBaskets extends SdkShopperBaskets<any> {
	/** @private */
	private ocapiConfig: any;

	/** @param {object} config - Commerce API configuration */
	constructor(config: any) {
		super(config);
		this.ocapiConfig = config;
	}

	/**
	 * Fetches approaching discounts for a basket via the OCAPI endpoint.
	 * @param {object} options - Request options with basketId parameter and optional headers.
	 * @returns {Promise<object>} The approaching discounts response with camelCase keys.
	 */
	async getApproachingDiscounts(options: {
		parameters: {basketId: string};
		headers?: Record<string, string>;
	}) {
		const {basketId} = options.parameters;
		const proxy = this.ocapiConfig.ocapiProxyPath || '';
		const host = this.ocapiConfig.ocapiHost
			? `https://${this.ocapiConfig.ocapiHost}`
			: `${getAppOrigin()}${proxy}`;
		const {siteId, clientId} = this.ocapiConfig.parameters;

		const response = await fetch(
			`${host}/s/${siteId}/dw/shop/v21_3/baskets/${basketId}/approaching_discounts`,
			{
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
					'x-dw-client-id': clientId,
					...options.headers,
				},
			}
		) as Response;

		const httpStatus = response.status;
		const json = await response.json();
		const converted = keysToCamel(json);

		if (converted.fault) {
			throw new HTTPError(httpStatus, convertOcapiFaultToCapiError(converted.fault));
		}

		return converted;
	}
}

export default ShopperBaskets;
